import React, { useState } from 'react';
import axiosInstance from '../../utils/axios';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const username = formData.username.trim();
            const response = await axiosInstance.post('/api/public/login', { ...formData, username });

            localStorage.setItem('authToken', response.data.token);
            localStorage.setItem('username', username);
            localStorage.setItem('userId', response.data.userId);
            navigate('/events');
            window.location.reload();
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.response?.data || "Kasutajanimi või parool on vale";
            setErrorMessage(errorMsg);
        }
    };
    return (
        <div className="login-container">
            <div className="login-box">
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label>Kasutajanimi</label>
                        <input type="text"
                               id="username"
                               name="username"
                               placeholder="Sisesta oma kasutajanimi"
                               value={formData.username}
                               onChange={handleChange}
                               required
                               autoComplete="username">
                        </input>
                    </div>
                    <div className="form-group">
                        <label>Parool</label>
                        <input type="password"
                               id="password"
                               name="password"
                               placeholder="Sisesta oma parool"
                               value={formData.password}
                               onChange={handleChange}
                               required
                               autoComplete="current-password">
                        </input>
                    </div>
                    <button type="submit">
                        Logi sisse
                    </button>
                    {errorMessage && (
                        <p className="error-message"
                           style={{ color: '#334155', marginTop: '10px', textAlign: 'center' }}>
                        {errorMessage}
                        </p>
                    )}
                    <div className="register-link">
                        Konto puudub?
                        <a href="/register">
                        Registeeri siin
                        </a>
                    </div>
                    <div className="forgot-password-link">
                        <a href="/forgot-password">
                        Unustasid parooli?
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginPage;

